import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <Navbar />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="relative w-full max-w-lg text-center">
          <p className="pointer-events-none select-none font-heading text-7xl font-black text-background-300 md:text-9xl">
            404
          </p>
          <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            页面走丢了
          </h1>
          <p className="mt-3 text-sm text-foreground-600">
            你访问的页面不存在或已被移除：
            <span className="ml-1 font-mono text-foreground-800">{location.pathname}</span>
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line text-lg" aria-hidden="true" />
              返回首页
            </Link>
            <Link
              to="/category/apple"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-apple-fill text-lg" aria-hidden="true" />
              浏览苹果视频
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}